function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import { SVG_PROP_TYPE, SIZE_PROP_TYPE, COLOR_PROP_TYPE, SHOULD_USE_RESET_PATTERN, VECTOR_IMAGE_ICON, VECTOR_IMAGE_BRAND, VECTOR_IMAGE_PAYMENT, VECTOR_IMAGE_GRAPHIC, VECTOR_IMAGE_ILLUSTRATION } from './constants';

var VectorImage =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(VectorImage, _PureComponent);

  function VectorImage() {
    _classCallCheck(this, VectorImage);

    return _possibleConstructorReturn(this, _getPrototypeOf(VectorImage).apply(this, arguments));
  }

  _createClass(VectorImage, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          svg = _this$props.svg,
          type = _this$props.type,
          size = _this$props.size,
          width = _this$props.width,
          height = _this$props.height,
          color = _this$props.color,
          strokeColor = _this$props.strokeColor,
          hasHalo = _this$props.hasHalo,
          haloColor = _this$props.haloColor,
          haloSize = _this$props.haloSize,
          animated = _this$props.animated,
          isBlockLevel = _this$props.isBlockLevel,
          title = _this$props.title,
          __containerClassName = _this$props.__containerClassName,
          children = _this$props.children;
      var className = classNames('eds-vector-image', (_classNames = {}, _defineProperty(_classNames, "eds-".concat(type, "--").concat(size), size), _defineProperty(_classNames, "eds-".concat(type, "--animated"), animated), _defineProperty(_classNames, "eds-vector-image--".concat(color), color), _defineProperty(_classNames, "eds-vector-image--stroke-".concat(strokeColor), strokeColor), _defineProperty(_classNames, 'eds-vector-image--block', isBlockLevel), _defineProperty(_classNames, 'eds-vector-image-size--reset', SHOULD_USE_RESET_PATTERN.test(type) || width && height || haloSize), _defineProperty(_classNames, 'eds-align--center', haloSize), _defineProperty(_classNames, 'eds-vector-image-halo-size-override', haloSize), _classNames), __containerClassName);
      var hiddenText;
      var accessibilityProps = {};
      var style; // NOTE: According to Alli we may want to always have a `title` for accessibility
      // reasons, so it'd be nice if we had a mapping of types to display names that
      // we can fallback to if the `title` isn't specified

      if (title) {
        hiddenText = React.createElement("span", {
          className: "eds-is-hidden-accessible"
        }, title);
      } else {
        accessibilityProps = _objectSpread({}, accessibilityProps, {
          'aria-hidden': true
        });
      }

      if (height && width) {
        style = {
          height: height,
          width: width
        };
      }

      var icon = React.createElement("i", _extends({
        className: className,
        title: title,
        "data-spec": "icon",
        style: style
      }, accessibilityProps), svg, hiddenText, children);

      if (hasHalo) {
        var _classNames2;

        var newHaloSize = size;

        if (haloSize) {
          newHaloSize = haloSize;
        }

        var haloClassName = classNames("eds-".concat(type, "--halo"), (_classNames2 = {}, _defineProperty(_classNames2, "eds-".concat(type, "-halo--").concat(newHaloSize), newHaloSize), _defineProperty(_classNames2, "eds-bg-color--".concat(haloColor), haloColor), _classNames2), __containerClassName);
        return React.createElement("span", {
          className: haloClassName
        }, icon);
      }

      return icon;
    }
  }]);

  return VectorImage;
}(PureComponent);

_defineProperty(VectorImage, "propTypes", {
  /**
   * The SVG of icon that you want to display
   * (or a component that renders and <svg />)
   */
  svg: SVG_PROP_TYPE.isRequired,

  /**
   * The type of icon that you want to display e.g. icon, brand, payment, graphic
   */
  type: PropTypes.oneOf([VECTOR_IMAGE_ICON, VECTOR_IMAGE_BRAND, VECTOR_IMAGE_PAYMENT, VECTOR_IMAGE_GRAPHIC, VECTOR_IMAGE_ILLUSTRATION]).isRequired,

  /**
   * Additional content to display next to svg
   */
  children: PropTypes.node,

  /**
   * The size of the icon
   */
  size: SIZE_PROP_TYPE,

  /**
   * The specified width of the icon
   */
  width: PropTypes.string,

  /**
   * The specified height of the icon
   */
  height: PropTypes.string,

  /**
   * The display the icon as a block level element
   */
  isBlockLevel: PropTypes.bool,

  /**
   * The fill color of the icon
   */
  color: COLOR_PROP_TYPE,

  /**
   * The stroke color of the icon
   */
  strokeColor: COLOR_PROP_TYPE,

  /**
   * Option to include a halo for the icon
   */
  hasHalo: PropTypes.bool,

  /**
   * Option to include a background color halo for the icon
   */
  haloColor: COLOR_PROP_TYPE,

  /**
   * Option to override the halo size.
   */
  haloSize: SIZE_PROP_TYPE,

  /**
   * Option to animate the icon
   * (Note: not all icons can be animated)
   */
  animated: PropTypes.bool,

  /**
   * Add a title attribute to the to icons markup
   */
  title: EBPropTypes.translation,
  __containerClassName: PropTypes.string
});

export { VectorImage as default };